export default __webpack_public_path__ + "static/media/comments.f865635c.svg";